import addIcon from "../assets/btn-add-complete.svg";
import deleteIcon from "../assets/btn-delete-complete.svg";
import almacenesIcon from "../assets/almacenes.svg";
import itemsIcon from "../assets/items.svg";
import searchIcon from "../assets/search.svg";
import editIcon from "../assets/icon-edit-white.svg";
import atencionIcon from "../assets/icon-atencion.svg";
import checkIcon from "../assets/icon-check.svg";
import calendarIcon from "../assets/branding/icon-calendar.svg";
import empleadosIcon from "../assets/branding/icon-empleados.svg";

//* Indicadores
import salesIcon from "../assets/branding/indicadores-icons/ventas.svg";
import ordersIcon from "../assets/branding/indicadores-icons/transacciones.svg";
import averageIcon from "../assets/branding/indicadores-icons/ticket-promedio.svg";

//* terminales bancarias
import csvIcon from "../assets/branding/terminales-bancarias/icon-csv.svg";
import newIcon from "../assets/branding/terminales-bancarias/icon-new.svg";

export const icons = {
  calendar: calendarIcon,
  add: addIcon,
  delete: deleteIcon,
  almacenes: almacenesIcon,
  items: itemsIcon,
  search: searchIcon,
  edit: editIcon,
  atencion: atencionIcon,
  check: checkIcon,
  sales: salesIcon,
  orders: ordersIcon,
  average: averageIcon,
  empleados: empleadosIcon,
  csv: csvIcon,
  new: newIcon,
};
